export * from './Presentation'
export * from './PresentationPages'

import Presentation from './Presentation'
export default Presentation
